// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_1ET9AVSKyzxrm72dyV0UUN","back":"_3qoPC2KQqtGhpWj5SwuFkc","white":"_29nqoCn7fkrJlXFqc2qbRY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.scss
 ** module id = 1048
 ** module chunks = 0
 **/